import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { HTML_ATTRIBUTE_CAPTURE_PREFIX, HTML_ATTRIBUTE_BLOCKER_CONNECTED, findVisualParentForContentBlocker } from ".";
import { putHtmlCodeToDom } from "..";
var HTML_ATTRIBUTE_TRANSFORM_WRAPPER = "consent-transform-wrapper";
var HTML_ATTRIBUTE_TRANSFORM_WRAPPER_VALUE = "1";
/**
 * Transform e. g. `consent-original-href` to `href` of a given node.
 */

function transformToOriginalContentBlockerAttribute(node) {
  return new Promise(function (resolve) {
    // Scripts need to be handled differently cause we want to use `postscribe` and should not be attached
    // to the DOM -> not be executed
    var isScript = node.tagName.toLowerCase() === "script";
    var workWithNode = isScript ? node.cloneNode(true) : node; // Do the transformation from "blocked" state to "unblocked"

    var _iterator = _createForOfIteratorHelper(workWithNode.getAttributeNames()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var attribute = _step.value;

        if (attribute.startsWith(HTML_ATTRIBUTE_CAPTURE_PREFIX)) {
          var originalAttribute = attribute.substr(HTML_ATTRIBUTE_CAPTURE_PREFIX.length + 1);
          workWithNode.setAttribute(originalAttribute, workWithNode.getAttribute(attribute));
          workWithNode.removeAttribute(attribute);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    workWithNode.style.removeProperty("display"); // Also make the parent visual visible again

    var visualParent = findVisualParentForContentBlocker(node);

    if (visualParent !== node || visualParent !== null && visualParent !== void 0 && visualParent.hasAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED)) {
      visualParent.style.removeProperty("display");
    }

    if (!isScript) {
      resolve();
    } else {
      // We do need to create a `span` for postscribe cause the <script> tag can not be used in this case
      var outerHTML = workWithNode.outerHTML; // Check if there is already a wrapper known

      var previousElementSibling = node.previousElementSibling;
      var referenceNode;

      if (previousElementSibling !== null && previousElementSibling !== void 0 && previousElementSibling.hasAttribute(HTML_ATTRIBUTE_TRANSFORM_WRAPPER)) {
        referenceNode = previousElementSibling;
      } else {
        referenceNode = document.createElement("div"); // we need to have a `block`ing element

        referenceNode.setAttribute(HTML_ATTRIBUTE_TRANSFORM_WRAPPER, HTML_ATTRIBUTE_TRANSFORM_WRAPPER_VALUE);
        node.parentElement.replaceChild(referenceNode, node);
      }

      putHtmlCodeToDom(outerHTML, {}, referenceNode).then(resolve);
    }
  });
}

export { transformToOriginalContentBlockerAttribute, HTML_ATTRIBUTE_TRANSFORM_WRAPPER, HTML_ATTRIBUTE_TRANSFORM_WRAPPER_VALUE };